import React from "react";

type HoverStyles = { color: string };

/**
 * Returns the styles to apply when an element is hovered over.
 * The returned object includes two functions, onEnter and onLeave,
 * which should be used as event handlers for the onMouseEnter and onMouseLeave events.
 * The returned object also includes the current styles object to apply to the element.
 *
 * @returns Object containing onEnter, onLeave, and styles properties
 */
const useHoverStyles = (): {
  onEnter: () => void;
  onLeave: () => void;
  styles: HoverStyles;
} => {
  const [styles, setHoverStyles] = React.useState<HoverStyles>({
    color: "white",
  });
  const onEnter = () => {
    setHoverStyles((prev) => {
      return { ...prev, color: "#8d9da7" };
    });
  };

  const onLeave = () => {
    setHoverStyles((prev) => {
      return { ...prev, color: "white" };
    });
  };

  return { onEnter, onLeave, styles };
};

export default useHoverStyles;
